
const ARCH_OPENINGS: Record<string, string[]> = {
    "6x8": ["4x6"],
    "8x10": ["5x7"],
    "11x14": ["7x10", "8x10"],
    "12x16": ["8x12"],
    "16x20": ["10x14", "11x14", "10x15", "12x16"],
    "16x24": ["12x18", "12x20"],
    "20x24": ["14x18", "16x20"],
    "20x30": ["14x24", "16x24", "16x26"],
    "24x34": ["20x30"],
    "30x40": ["24x34", "26x36"],
};


const FMOUNTS_OPENINGS: Record<string, string[]> = {
     //Vertical
    "8x10": ["4x6", "5x5", "5x7", "5x7.5", "6x8"],
    "11x14": ["6x8", "6x9", "7x7", "7x10", "8x10", "8x12"],
    //Horizontal
    "10x8": ["6x4", "5x5", "7x5", "7.5x5", "8x6"],
    "14x11": ["8x6", "9x6", "7x7", "10x7", "10x8", "12x8"],
};


const FPRINTS_OPENINGS: Record<string, string[]> = {
     //Vertical
    "8x10": ["5x7"],
    "11x14": ["7x10", "8x10"],
    "12x16": ["8x12"],
    "16x20": ["10x14", "10x15", "11x14", "12x16"],
    "16x24": ["12x18", "12x20"],
    "20x24": ["14x18", "16x20"],
    "20x30": ["14x24", "16x24", "16x26"],
    "24x34": ["20x30"],
    "30x40": ["24x34", "26x36"],

    //Horizontal
    "10x8": ["7x5"],
    "14x11": ["10x7", "10x8"],
    "16x12": ["12x8"],
    "20x16": ["14x10", "15x10", "14x11", "16x12"],
    "24x16": ["18x12", "20x12"],
    "24x20": ["18x14", "20x16"],
    "30x20": ["24x14", "24x16", "26x16"],
    "34x24": ["30x20"],
    "40x30": ["34x24", "36x26"],

    //Square
    "10x10": ["8x8"],
    "12x12": ["8x8", "10x10"],
    "14x14": ["12x12", "10x10"],
    "16x16": ["12x12"],
    "20x20": ["16x16", "14x14"],
    "24x24": ["20x20", "18x18"],
    "30x30": ["26x26", "24x24"],
    "40x40": ["36x36", "34x34"],
};



const HANDTORN_OPENINGS: Record<string, string[]> = {
    //Vertical
    "6x8": ["4x6"],
    "8x10": ["5x7"],
    "11x14": ["7x10", "8x10"],
    "12x16": ["8x12"],
    "16x20": ["10x14", "10x15", "11x14", "12x16"],
    "16x24": ["12x18", "12x20"],
    "20x24": ["14x18", "16x20"],
    "20x30": ["14x24", "16x24", "16x26"],
    "24x34": ["20x30"],
    "30x40": ["24x34", "26x36"],

    //Horizontal
    "8x6": ["6x4"],
    "10x8": ["7x5"],
    "14x11": ["10x7", "10x8"],
    "16x12": ["12x8"],
    "20x16": ["14x10", "15x10", "14x11", "16x12"],
    "24x16": ["18x12", "20x12"],
    "24x20": ["18x14", "20x16"],
    "30x20": ["24x14", "24x16", "26x16"],
    "34x24": ["30x20"],
    "40x30": ["34x24", "36x26"],

    //Square
    "8x8": ["6x6"],
    "10x10": ["8x8"],
    "12x12": ["8x8", "10x10"],
    "14x14": ["12x12", "10x10"],
    "16x16": ["12x12"],
    "20x20": ["16x16", "14x14"],
    "24x24": ["20x20", "18x18"],
    "30x30": ["26x26", "24x24"],
    "40x40": ["36x36", "34x34"],
};


export const OPENING_MAP: Record<string, Record<string, string[]>> = {
    ARCH: ARCH_OPENINGS,
    FMOUNTS: FMOUNTS_OPENINGS,
    FPRINTS: FPRINTS_OPENINGS,
    HANDTORN: HANDTORN_OPENINGS,
}